import { $win, $body } from '../utils/globals';
import 'slick-carousel';

$win.on('load', function () {
  initHeroSlider();
  initProductSliders();
  initMembersSlider();
  initTestimonialsSlider();
  initProductItemsSlider();
  articlesSlider();
});

// Hero Slider

function initHeroSlider() {
  $('.js-hero-slider').each(function () {
    const $this = $(this);
    const $slide = $this.find('.js-hero-slide');

    if ($slide.length > 1) {
      $this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        fade: true,
        cssEase: 'linear',
        arrows: false,
        dots: false,
      });
    }
  });
}

// PDP Slider

function initProductSliders() {
  $('.js-product-slider').each(function () {
    const $this = $(this);

    $this.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: '.js-product-thumbs-slider',
    });
  });

  $('.js-product-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.js-product-slider')
      .find('video')
      .each(function () {
        $(this)[0].pause();
      });
  });

  $('.js-product-thumbs-slider').each(function () {
    const $this = $(this);

    $this.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical: true,
      dots: false,
      arrows: false,
      infinite: false,
      asNavFor: '.js-product-slider',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            vertical: false,
            slidesToShow: 3.7,
          },
        },
        {
          breakpoint: 767,
          settings: {
            vertical: false,
            slidesToShow: 3.7,
          },
        },
      ],
    });
  });
}

// Members slider

function initMembersSlider() {
  $('.js-members-slider ul').each(function () {
    const $this = $(this);
    const $slide = $this.find('.js-members-slide');

    if ($slide.length > 1) {
      $this.slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.73,
              infinite: false,
            },
          },
        ],
      });
    }
  });
}

// Testimonials slider

function initTestimonialsSlider() {
  $('.js-testimonials-slider ul').each(function () {
    const $this = $(this);
    const $slide = $this.find('.js-testimonials-slide');

    if ($slide.length > 1) {
      $this.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 600,
        arrows: true,
        dots: false,
      });
    }
  });
}

// Product Listing Slider

function initProductItemsSlider() {
  $('.js-product-items-slider').each(function () {
    const $this = $(this);
    const $slide = $this.find('.js-product-items-slide');

    if ($slide.length > 1) {
      $this.slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
      });
    }
  });
}

// Product Listing Slider

function articlesSlider() {
  $('.js-articles-slider').each(function () {
    const $this = $(this);

    $this.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.15,
          },
        },
      ],
    });
  });
}
